import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const LanguageSwitcher = ({ className = "" }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fa' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <motion.button
      onClick={toggleLanguage}
      className={`px-3 py-1 bg-safir-primary text-white rounded-lg text-sm font-medium hover:bg-safir-secondary transition-colors ${className}`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={i18n.language === 'en' ? 'Switch to Persian' : 'Switch to English'}
    >
      {i18n.language === 'en' ? 'فارسی' : 'English'}
    </motion.button>
  );
};

export default LanguageSwitcher;
